import * as React from 'react';
import {ProvidedGlobalProps, withGlobalProps} from '../../providers/globalPropsProvider';
import s from './ViewMore.scss';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {compose} from '../../../commons/utils';

function ViewMoreComponent({
  t,
  globals: {navigate, product, experiments},
}: ProvidedGlobalProps & IProvidedTranslationProps) {
  return (
    <a
      data-hook="quick-view-more"
      className={s.root}
      onClick={(e) => {
        /* istanbul ignore next */
        if (experiments.quickViewFixViewMoreLink) {
          e.preventDefault();
        }
        navigate(product.urlPart, true);
      }}
      href={experiments.quickViewFixViewMoreLink ? product.urlPart : undefined}>
      {t('productPage.quickView.viewProductDetails')}
    </a>
  );
}

export const ViewMore = compose(withTranslations('globals.texts'), withGlobalProps)(ViewMoreComponent);
